import { forwardRef, type PropsWithChildren } from "react";
import { customColors } from "tailwind.config";

import { WarningIcon } from "$/lib/icons/WarningIcon";

import { BaseTextArea } from "../../atoms";
import type { TextAreaProps } from "./TextArea.types";

const TextArea = forwardRef<
  HTMLTextAreaElement,
  PropsWithChildren<TextAreaProps>
>(
  (
    {
      label,
      isError,
      hintMessage,
      errorMessage = "This field is required",
      ...props
    },
    ref,
  ) => {
    return (
      <div className="flex w-full flex-col gap-1.5">
        {label && (
          <label
            className="text-left text-sm font-medium text-neutral-900"
            htmlFor={props.id || props.name}
          >
            {label}
          </label>
        )}
        <BaseTextArea {...props} ref={ref} />

        {hintMessage && (
          <p className="mt-1 flex items-center gap-2 text-xs text-tertiary-500">
            {hintMessage}
          </p>
        )}

        {isError && errorMessage && (
          <p className="mt-1 flex items-center gap-1 text-xs text-error">
            <WarningIcon
              color={customColors.error.DEFAULT}
              className="size-4"
            />
            {errorMessage}
          </p>
        )}
      </div>
    );
  },
);

TextArea.displayName = "TextArea";

export default TextArea;
